import { Controller } from "@hotwired/stimulus"


  export default class extends Controller {
    static targets = ['button'];

    connect() {
      //console.log('Button controller connected');
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const button = event.currentTarget;
      const course_id = button.getAttribute('course-id');

      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      fetch('/students/enrollments', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({ course_id: course_id})
      })
        .then(response => response.json())
        .then(data => {
          console.log(data.result);
            // this.showToast(data.status,data.message);
            if (data.status == "success"){
              setTimeout(() => {
                window.location.reload();
              }, 500); 
            }
        })
        .catch(error => {
          // Handle any errors
        });
    }

    // showToast(title, body) {
    //   //document.querySelector('#toast_message').classList.remove('d-none');
    //   window.scrollTo(0, 0);
    //   document.querySelector('.toast').classList.remove('hide');
    //   document.querySelector('.toast').classList.add('show');
    //   document.querySelector('#toast_message').classList.remove('d-none');
    //   const toastTitle = document.querySelector('.toast-title');
    //   const toastBody = document.querySelector('.toast-body');
    //   toastTitle.textContent = title;
    //   toastBody.textContent = body;
    // }

}
